import { useTranslation } from 'react-i18next';
import useClientConfig from '../hooks/clientConfigHook';
import { cdate } from '../utils/CDate';
import DateInput from './DateInput';
import { Col, Row } from './Grid';
import Label from './Label';
import TimeInput from './TimeInput';
import PropTypes from 'prop-types';

export const toString = ({ value, tz, args, defaultValue, def, clientConfig }) => {
    if (!value) {
        return defaultValue;
    }
    return cdate(value, args?.tz ?? def.tz ?? tz ?? clientConfig.tz).dateTimeFormat(def?.showTz ?? clientConfig.timezones?.enable, true);
}

const DateTimeInput = ({ value, placeholder, tz, showTZ, hideLabel = false, disabled = false, readonly = false, required = false, onChange, ...props }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();

    if (readonly) {
        let time = cdate(value, tz ?? clientConfig.tz)
        return <Label hideLabel={hideLabel} placeholder={placeholder} text={time?.isValid?.() ?  time.dateTimeFormat(showTZ ?? clientConfig.timezones?.enable, true) : '\u00A0' }></Label>;
    } else {
        return <Row>
            <Col xs={6}>
                <DateInput value={value} placeholder={`${placeholder} ${t('date')}`} disabled={disabled} required={required} tz={tz} hideLabel={hideLabel} onChange={onChange} {...props}></DateInput>
            </Col>
            <Col xs={6}>
                <TimeInput value={value} placeholder={`${placeholder} ${t('time')}`} disabled={disabled} required={required} tz={tz} hideLabel={hideLabel} onChange={onChange} {...props}></TimeInput>
            </Col>
        </Row>;
    }
}
DateTimeInput.propTypes = {
    /**
     * The date to be displayed by the control as an ISO string
     */
    value: PropTypes.string,

    /**
     * The timezone in which to render the date, defaults to clientConfig.tz.
     * Timezone is expressed as a TZ identifier like Australia/Brisbane or Europe/London
     */
    tz: PropTypes.string,

    /**
     * Whether to show the timezone when rendering values
     */
    showTZ: PropTypes.bool,

    /**
     * Function to call when the value has been changed
     */
    onChange: PropTypes.func,

    /**
     * The label for the control
     */
    placeholder: PropTypes.string,

    /**
     * The control must have a value for the from in which it is contained to validate
     */
    required: PropTypes.bool,

    /**
     * Force the input to be read-only
     */
    disabled: PropTypes.bool,

    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool,

    /**
     * Render the control as inline text rather than as an input control
     */
    readonly: PropTypes.bool
};

export default DateTimeInput;